export default __webpack_public_path__ + "static/splash-c469ee8c809c5628466be78402721195.png";